import axios from 'axios'
import qs from 'qs'
import router from '../router/index'
import global from '@/utils/global'
import Vue from 'vue'
/**
 * 根据环境变量使用不同的接口服务器地址
 */
switch (process.env.NODE_ENV) {
  case 'production':
    // 生产环境
    axios.defaults.baseURL = 'http://uumapi.ddzzii.com'
    break
  case 'test':
    // 测试环境
    axios.defaults.baseURL = 'http://uumapi.ddzzii.com'
    break
  default:
    // 开发环境
    axios.defaults.baseURL = 'http://uumapi.ddzzii.com'
}

/**
 * 设置超时时间 和 跨域是否允许携带凭证
 */
// 10秒
axios.defaults.timeout = 10000
// 不设置true 跨域请求无法携带cookie
axios.defaults.withCredentials = true

/**
 * 设置post请求传递数据的格式 x-www-form-urlencoded
 */
// x-www-form-urlencoded
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// post 请求数据对象转换为 xxx=xxx&xxx=xxx 格式
// axios.defaults.transformRequest = data => qs.stringify(data)

// 不同的请求头对数据进行不同的封装
axios.defaults.transformRequest = (data, headers) => {
  if (headers['Content-Type'] === "multipart/form-data") {
    // 文件上传
    let formData = new FormData()
    for (let k in data) {
      formData.append(k, data[k])
    }
    return formData
  }else {
    // 普通数据
    return qs.stringify(data)
  }
}

/**
 * 设置请求拦截器
 * TOKEN 校验（JWT）：接收服务器返回的token，存储到vuex/本地存储中， 每一次向服务器发请求，带上token
 */
axios.interceptors.request.use(config => {
  // token 设置
  let token = Vue.$cookies.get('token')
  token && (config.headers.token = token)
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 设置响应拦截器
 */
// 默认只有2开头的响应是成功的，如果有3开头响应时需要自定义
// axios.defaults.validateStatus = status => {
//     // 自定义响应成功的HTTP状态码
//     return /^(2|3)\d{2}$/.test(status)
// }
axios.interceptors.response.use(response => {
  // 响应成功 2xx, 只返回data
  return response.data
}, error => {
  // 响应失败
  let {response} = error
  if (response) {
    // 服务器返回结果
    switch (response.status) {
      case 401:  // 当前请求需要用户验证 一般Token过期
        // 删除token
        Vue.$cookies.remove('token', '/', global.cookieDomain)
      case 403: // 服务器接收请求，但拒绝执行；无token
        // 跳转到刷新token
        router.replace({name:'Login'})
        break
      case 404: // 找不到资源
        // router.replace({name:'Page404'})
        break
      default:

      //
    }
  } else {
    // 服务器没有返回结果 服务器崩溃或断网
    if (!window.navigator.onLine) {
      // 断网处理：可以跳转到断网页面
      console.log('断网')
      return
    }
    console.log(error)
    return Promise.reject(error)
  }
})

export default axios
